import { ThemeContext } from "../theme/ThemeProvider";

export default ThemeContext;
